import { render } from "./CertificationForm.vue?vue&type=template&id=60ecff80&scoped=true"
import script from "./CertificationForm.vue?vue&type=script&lang=js"
export * from "./CertificationForm.vue?vue&type=script&lang=js"

import "./CertificationForm.vue?vue&type=style&index=0&id=60ecff80&scoped=true&lang=css"

import exportComponent from "/Users/alekseisemiguk/Documents/sadko/35FIT-full/35FIT/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60ecff80"]])

export default __exports__